import { Location } from "@remix-run/react";
import { ProductDetailsResponse, getProductService } from "core/catalog";
import { pageHead } from "framework/config/meta";
import { publicRoutes } from "framework/config/middlewares";

export const loader = publicRoutes(
  async ({ http, params, success, catchErrors }) => {
    const { id } = params;

    try {
      const response = await getProductService(http, id as string);

      return success(response);
    } catch (error) {
      catchErrors(error);
    }
  },
);

export const meta = ({
  data,
  location,
}: {
  data: ProductDetailsResponse;
  location: Location;
}) => {
  if (!data?.meta) return [];

  return pageHead({
    ...data.meta,
    location,
  });
};
